import {makeStyles} from "@mui/styles";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import GoogleMapReact from "google-map-react";
import React from "react";

import {GoogleMapReactURLKeys} from "../../config";
import {Marker} from "./Marker";

const useStyles = makeStyles(
  () => ({
    container: {
      height: "40vh",
      margin: "20px 0",
      width: "100%",
    },
  }),
  {
    name: "Map",
  }
);

export const Map: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <GoogleMapReact
        bootstrapURLKeys={{key: GoogleMapReactURLKeys}}
        center={{
          lat: 22.427532586716442,
          lng: 114.20814895344444,
        }}
        zoom={17}
      >
        <Marker
          lat={22.427532586716442}
          lng={114.20814895344444}
          text="Building 19W"
        />
      </GoogleMapReact>
    </div>
  );
};
